<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-setting-areas'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-setting-areas"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="data">
            <span class="text-warning"> {{ data.value | capitalize }} </span>
          </template>

          <template #cell(roles)="data">
            <b-badge
              v-for="item in data.value"
              :key="item.id"
              pill
              :variant="`light-primary`"
              class="mr-1"
            >
              <span> {{ item.name | capitalize }}</span>
            </b-badge>
          </template>

          <template #cell(created_at)="data">
            <span style="opacity: 0.6"> {{ data.value | myGlobalDay }} </span>
          </template>

          <template #cell(updated_at)="data">
            <span style="opacity: 0.6"> {{ data.value | myGlobalDay }} </span>
          </template>

          <template #cell(id)="data">
            <!-- Approve Discount -->
            <!-- <feather-icon
              v-if="tab == 'pending'"
              icon="CheckSquareIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('Approve Discount')"
              @click="openDiscountModal(data.item, 'approve')"
            /> -->

            <!-- Edit Discount -->
            <feather-icon
              icon="EditIcon"
              class="cursor-pointer text-warning ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Edit Role')"
              @click="editArea(data.item.id)"
            />

            <!-- View Tracking -->
            <!-- <feather-icon
              v-if="tab != 'pending'"
              icon="ListIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('View Tracking')"
              @click="openDiscountTrackingModal(data.item)"
            /> -->

            <!-- Anulle Discount -->
            <!-- <feather-icon
              v-if="tab == 'pending'"
              icon="Trash2Icon"
              class="cursor-pointer text-danger ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Anulle Discount')"
              @click="openDiscountModal(data.item, 'anulle')"
            /> -->
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AreaModal
      v-if="areaModal"
      :areaId="areaId"
      @hideModal="areaModal = false"
      @refreshTable="
        areaModal = false;
        $refs['ref-table-setting-areas'].refresh();
      "
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/settings/views/roles-area/data/fields-area.data.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

/* Modals */
import RoleModal from "@/views/settings/views/roles-area/components/modals/RoleModal.vue";
import AreaModal from "@/views/settings/views/roles-area/components/modals/AreaModal.vue";

/* Services */
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import RolesAreaService from "@/views/settings/views/roles-area/service/roles-area.service.js";

export default {
  components: {
    FilterSlot,
    RoleModal,
    AreaModal,
  },
  props: {
    tab: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      filters: [],
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      areaId: null,
      areaModal: false,
    };
  },
  computed: {
    showFields() {
      this.fields.map((row) => (row.visible = true));

      let fieldsVisible = this.fields.filter((item) => item.visible);
      return fieldsVisible;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {},
  methods: {
    async myProvider(ctx) {
      try {
        let order = 2;
        switch (ctx.sortBy) {
          case "name":
            order = 2;
            break;
          default:
            order = 2;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
        };
        const { data } = await RolesAreaService.getAreas(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    editArea(id) {
      this.areaId = id;
      this.areaModal = true;
    },

    newArea() {
      this.areaId = null;
      this.areaModal = true;
    },
  },
};
</script>

<style>
</style>
